import { programs } from './Course';

const CoursePreview = () => {
    
    const visiblePrograms = programs.filter(program =>
        [2, 4, 5].includes(program.id)
    );

    return (
        <section className="section-padding">
            <div className="container">
                {/* Section Header */}
                <div className="text-center mb-5">
                    <h2 className="section-title">
                        Pilih Program yang Tepat Sesuai Tujuan Kamu
                    </h2>
                    <p className="section-subtitle text-muted mt-2">
                        Jelajahi program bahasa Inggris terpopuler kami yang dirancang untuk mendukung perjalanan global kamu.
                    </p>
                </div>

                {/* Program Cards */}
                <div className="program-grid">
                    {visiblePrograms.map((program) => (
                        <div key={program.id} className="program-card-2 hover-lift">
                            <div className="program-image-wrapper">
                                <img
                                    src={program.image}
                                    alt={program.title}
                                    className="program-image"
                                    loading="lazy"
                                />
                            </div>

                            <div className="program-content">
                                <span className="program-caption-2 text-danger">
                                    {program.caption}
                                </span>
                                <h3 className="program-title">{program.title}</h3>
                                <p className="program-body">{program.body}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* CTA */}
                <div className="text-center">
                    <a
                        className="btn btn-danger btn-lg px-5"
                        href="/course"
                    >
                        Lihat Semua Kursus
                    </a>
                </div>
            </div>
        </section>
    );
};

export default CoursePreview;